module.exports = "<pre> {{resp | json}} </pre>\n\n<pre *ngIf=\"resp && resp.last_test_date\"> Last test time: {{resp.last_test_date*1000 | date:'MMMM d, y H:mm'}} </pre>\n<pre *ngIf=\"resp && resp.latest_ping\"> last ping time: {{resp.latest_ping.created_at*1000 | date:'MMMM d, y H:mm'}} </pre>\n\n\n<app-loader [isLoading]=\"loading\" style=\"display:inline-block\"></app-loader>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-diagnostics-dialog/kiosk-diagnostics-dialog.component.html
// module id = ./src/app/kiosk-diagnostics-dialog/kiosk-diagnostics-dialog.component.html
// module chunks = main